import { render, staticRenderFns } from "./PersonalInfoRequirement.vue?vue&type=template&id=21e292f8&scoped=true"
import script from "./PersonalInfoRequirement.vue?vue&type=script&lang=ts"
export * from "./PersonalInfoRequirement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e292f8",
  null
  
)

export default component.exports